/**
 * Public card for the vendor invite page. Neutral wording only.
 * The vendor is not described as verified, confirmed, certified, or approved.
 */

function present(value) {
  return String(value == null ? '' : value).trim();
}

function safeBrandColor(value) {
  const color = present(value);
  return /^#[0-9a-fA-F]{6}$/.test(color) ? color : '';
}

function httpsUrl(value) {
  const raw = present(value);
  if (/^https:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/') && !raw.startsWith('//') && !raw.includes('\\')) return raw;
  return '';
}

function inviteAgentName(agent) {
  if (!agent || typeof agent !== 'object') return '';
  return present(`${agent.first_name || ''} ${agent.last_name || ''}`);
}

function inviteHeadline(agent) {
  const name = inviteAgentName(agent);
  if (!name) return 'You were invited to join recommended service providers';
  return `${name} invited you to join their recommended service providers`;
}

function inviteBrand(agent) {
  if (!agent || typeof agent !== 'object') return null;
  const name = inviteAgentName(agent);
  const logoUrl = httpsUrl(agent.logo_url);
  const photoUrl = httpsUrl(agent.headshot_url);
  const brandColor = safeBrandColor(agent.brand_color);
  if (!name && !logoUrl && !photoUrl && !brandColor) return null;
  return {
    name,
    headline: inviteHeadline(agent),
    logoUrl,
    photoUrl,
    brandColor: brandColor || '#0f766e',
  };
}

module.exports = {
  safeBrandColor,
  httpsUrl,
  inviteAgentName,
  inviteHeadline,
  inviteBrand,
};
